<template>
    <transition name="el-notification-fade">
        <div class="light-tip el-notification" :class="show ? 'show' : ''" ref="lightTip">
            <span v-if="type == 'success'"><i class="icon el-icon-success"></i><span class="title">{{ msg }}</span></span>
            <!-- <span v-else><i class="icon el-icon-error"></i><span class="title">制作失败，请稍候重试</span></span> -->
        </div>
    </transition>
</template>
<script>
export default {
    name: 'lightTip',
    props: {
        msg: { type: String },
        type: { type: String },
    },
    data() {
        return {
            show: false,
            timer: null,
        }
    },

    mounted() {
        setTimeout(() => {
            this.show = true;
        }, 0);

    },
    watch: {
        show: function (newV) {
            if (this.timer) {
                clearTimeout(this.timer);

            }
            this.timer = setTimeout(() => {
                this.show = false;
                this.type = undefined;
                this.msg = "";
                this.$refs.lightTip.parentNode && this.$refs.lightTip.parentNode.removeChild(this.$refs.lightTip);
                clearTimeout(this.timer);
                this.timer = null;
            }, 2500);

        }
    }
}
</script>
<style scoped lang="scss">
.light-tip {
    // box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
    // border-radius: 6px;
    // border: 1px solid #DCDCDC;
    color: #000;
    font-weight: 400;
    width: auto;
    display: flex;
    align-items: center;
    padding: 13px 16px;
    position: fixed;
    top: 0;
    opacity: 0;
    left: 50%;
    transform: translateX(-50%);

    >span {
        display: flex;
        align-items: center;
    }

    .title {
        margin-left: 9px;
        word-break: keep-all;
        white-space: nowrap;
        font-size: 14px;
    }

    .icon {
        height: 18px;
        width: 18px;
        font-size: 18px;
    }

    &.show {
        top: 20px;
        opacity: 1;
        z-index: 1999;
    }
}
</style>
  